import React from "react";
import CustomDraggableDialog from "../common/customDialog/CustomDraggableDialog";
import TranslatedMessage from "../translations/TranslatedMessage";

type ConfirmPublishResultsDialogProps = {
  isOpen: boolean;
  onAccept: () => void;
  onCancel: () => void;
};

export default function ConfirmPublishResultsDialog({ isOpen, onAccept, onCancel }: ConfirmPublishResultsDialogProps) {
  return (
    <CustomDraggableDialog
      acceptText={<TranslatedMessage id="common.accept" />}
      cancelText={<TranslatedMessage id="common.cancel" />}
      content={<TranslatedMessage id="examSession.confirmPublishResultsDialog.text" />}
      isOpen={isOpen}
      onAccept={onAccept}
      onCancel={onCancel}
      title={<TranslatedMessage id="common.attention" />}
    />
  );
}
